import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "settings-form-container" }
const _hoisted_2 = { class: "settings-form" }
const _hoisted_3 = { class: "image-slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t("settings.title")), 1),
      _createVNode(_component_el_form, {
        model: _ctx.form,
        rules: _ctx.rules,
        ref: "formRef",
        onSubmit: _withModifiers(_ctx.handleSave, ["prevent"]),
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('settings.username'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                placeholder: _ctx.$t('settings.usernamePlaceholder')
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: "邮箱",
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                disabled: ""
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "success",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (console.log(123)))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("修改", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_collapse, {
            modelValue: _ctx.activeNames,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeNames) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_collapse_item, {
                title: "修改密码",
                name: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('settings.password'),
                    prop: "password"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        modelValue: _ctx.form.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.password) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('settings.newPassword'),
                    prop: "newPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        modelValue: _ctx.form.newPassword,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.newPassword) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('settings.confirmPassword'),
                    prop: "confirmNewPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        modelValue: _ctx.form.confirmNewPassword,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.confirmNewPassword) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_form_item, {
            label: "身份",
            prop: "identity"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.form.identity,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.identity) = $event)),
                clearable: "",
                style: {"width":"240px"},
                placeholder: "请选择",
                disabled: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('settings.avatar')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                class: "avatar-uploader",
                action: _ctx.UpdateApi,
                "show-file-list": false,
                "on-success": _ctx.handleAvatarSuccess,
                "before-upload": _ctx.beforeAvatarUpload,
                limit: 1,
                "file-list": _ctx.fileList,
                disabled: _ctx.allowUpload
              }, {
                default: _withCtx(() => [
                  (_ctx.imageUrl)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: _ctx.imageUrl,
                        class: "avatar",
                        alt: "",
                        fit: 'contain'
                      }, {
                        error: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_icon_picture)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_el_icon, {
                        key: 1,
                        class: "avatar-uploader-icon"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["action", "on-success", "before-upload", "file-list", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.allowUpload)
            ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    onClick: _ctx.clearImage
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("settings.clearImg")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.handleSave
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("settings.save")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.back(-1)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("settings.back")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "onSubmit"])
    ])
  ]))
}